import { IApplicationState } from '../../../types/redux';

/**
 * Показано ли menu в мобилке
 */
export const isMobileMenuOpenedSelect = ({ menu }: IApplicationState) => menu.isMobileMenuOpened;
